import { Component, computed, input } from '@angular/core';
import { AnnouncementResponse } from '@core/services/announcement';
import { NgClass } from '@angular/common';

type AnnouncementMode = 'info' | 'warning' | 'danger' | 'success';

@Component({
  selector: 'app-announcement',
  imports: [NgClass],
  templateUrl: './announcement.html',
  styleUrl: './announcement.scss',
})
export class Announcement {
  announcementItem = input<AnnouncementResponse | null>(null);
  mode = input<AnnouncementMode>('info');
  
  protected alertClass = computed(() => `alert-${this.mode()} alert-${this.mode()}-custom`);

  protected iconClass = computed(() => {
    const icons: Record<AnnouncementMode, string> = {
      info:    'fa-circle-info',
      warning: 'fa-triangle-exclamation',
      danger:  'fa-circle-exclamation',
      success: 'fa-circle-check',
    };
    return icons[this.mode()];
  });

}
